const tr = {
    faq:{
      attributes:{
        name:                   'Nome',
        sorter:                 'Ordenação',
        category:               'Categoria',
        faq_category_id:        'Categoria',
        is_active:              'Ativo',
        folder:                 'Pasta',
        title:                  'Título',
        faq_folder_id:          'Pasta',
        description:            'Descrição',
        published:              'Publicado',
        created_at:             'Criado em',
        updated_at:             'Última atualização',
      },
      extras:{
        category_new: 'Nova categoria',
        folder_new: 'Nova pasta',
        article_new: 'Nova solução',
        save_category: 'Categoria salva com sucesso!',
        save_folder: 'Pasta salva com sucesso!',
        save_article: 'Artigo salvo com sucesso!',
        edit_category: 'Categoria editada com sucesso!',
        edit_folder: 'Pasta editada com sucesso!',
        edit_article: 'Artigo editado com sucesso!',
        article_edit: 'Editar solução',
      },
    }
  };
  
  export default tr;
  